'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogArchive = void 0;
const $ = require("jquery");
class BlogArchive {
    constructor() {
        const self = this;
        // 画像のリンクを拾ってボックスをリンクに変える
        const ArchiveBoxes = $('.bulletTransPermalink');
        const ArchiveLinks = $('.paramTransPermalink');
        if (ArchiveLinks.length > 0) {
            for (let i = 0; i < ArchiveLinks.length; i++) {
                const ArchiveLink = ArchiveLinks.eq(i);
                const Anchor = ArchiveLink.find('a');
                const permalink = Anchor.attr('href');
                // 画像の a タグを span に変更
                Anchor.replaceWith('<span>' + Anchor.html() + '</span>');
                // ボックスの div タグを a に変更
                const ArchiveBox = ArchiveBoxes.eq(i);
                const ArchiveBoxClass = ArchiveBox.attr('class').replace('bulletTransPermalink', '');
                // console.log(ArchiveBox, ArchiveBoxClass);
                const ArchiveBoxHtml = '<a href="' + permalink + '" class="' + ArchiveBoxClass + '">' + ArchiveBox.html() + '</a>';
                ArchiveBox.replaceWith(ArchiveBoxHtml);
            }
        }
    }
}
exports.BlogArchive = BlogArchive;
exports.default = BlogArchive;
